import { render } from "./DateActualDataSubtitle.vue?vue&type=template&id=6d004ba8&scoped=true&ts=true"
import script from "./DateActualDataSubtitle.vue?vue&type=script&lang=ts"
export * from "./DateActualDataSubtitle.vue?vue&type=script&lang=ts"

import "./DateActualDataSubtitle.vue?vue&type=style&index=0&id=6d004ba8&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d004ba8"]])

export default __exports__